export const transactionType = {
	DEBIT: 1,
	CREDIT: 2,
};

export const categoryIds = {
	deposits: 1,
	withdrawals: 2,
	wins: 4,
};
